import getStore from '../store/store';
import type { FileProviderType } from '../utils/constants';

function isProviderBeingRemoved(providerType: FileProviderType): boolean {
    return getStore().removalPending.has(providerType.toString());
}

export { isProviderBeingRemoved };
